export type ModificationTypeOption = {
  name: string;
  value: string;
};

export const modificationTypeOptions: ModificationTypeOption[] = [
  {
    name: 'topics:modification-type:options:base',
    value: 'base',
  },
  {
    name: 'topics:modification-type:options:colour',
    value: 'colour',
  },
  {
    name: 'topics:modification-type:options:fragrance',
    value: 'fragrance',
  },
];
